export default __webpack_public_path__ + "static/media/Gaylord Ngendo.2033b38d.JPG";